<template>
  <v-card flat class="container--fluid">
    <v-card flat class="container--fluid bg-gray no-margins elevation-1 not-rounded">
      <v-card flat class="v-card__container">
        <h4>Distansutbildningar</h4>

        <v-select
            outlined
            :items="distanceEducationProviders"
            item-value="key"
            item-text="value"
            v-model="distanceEducationProviderId"
            @change="fetchEducations(); fetchExtensions();"
            class="distance-select"
            :placeholder="!distanceEducationProviderId ? 'Välj distansutbildare' : undefined"
        />

        <v-row class="flex justify-end mb-3">
          <v-btn v-if="tab === 1" @click="showExtensionDialog()">Add</v-btn>
        </v-row>

        <v-tabs v-model="tab" v-if="distanceEducationProviderId">
          <v-tab key="1" class="text-uppercase bold">Kurspriser</v-tab>
          <v-tab key="2" class="text-uppercase bold">Förlängning</v-tab>
        </v-tabs>
        <v-tabs-items v-if="distanceEducationProviderId" v-model="tab">
          <v-tab-item key="1">
            <v-data-table
              :headers="[
                  {text: 'Kurs', value: 'name'},
                  {text: 'Yrke', value: 'professionId'},
                  {text: 'Pris (exkl. moms)', value: 'price'},
                  {text: 'Ändra', value: 'actions', align: 'center', sortable: false}
                ]"
                :items="courses"
                :loading="isLoading"
                item-key="id"
                flat
                class="mt-6 mx-6"
            >
              <template slot="item.actions" slot-scope="props">
                <v-btn text @click="editItem(props.item)">
                  <v-icon class="mr-1">$sl-edit</v-icon>
                </v-btn>
              </template>
              <template slot="item.professionId" slot-scope="props">
                <div style="width: 150px;">{{ getProfessionNameById(props.item.professionId) }}</div>
              </template>
              <template slot="item.price" slot-scope="props">
                <div style="width: 80px;">{{ props.item.price | validCurrency | withCurrencyCode }}</div>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item key="2">
            <v-data-table
                :headers="[
                  {text: 'Förlängning', value: 'months'},
                  {text: 'Pris (exkl. moms)', value: 'price'},
                  {text: 'Ändra', value: 'actions', align: 'center', sortable: false}
                ]"
                :items="distanceEducationProviderExtensions"
                :loading="isLoading"
                item-key="id"
                flat
                class="mt-6 mx-6"
            >
              <template slot="item.months" slot-scope="props">
                {{ props.item.months }} {{ 'män'.toLocaleUpperCase() }}
              </template>
              <template slot="item.price" slot-scope="props">
                <div style="width: 80px;">{{ props.item.price ? (props.item.price | validCurrency | withCurrencyCode) : 'gratis' }}</div>
              </template>
              <template slot="item.actions" slot-scope="props">
                <v-btn text @click="showExtensionDialog(props.item)">
                  <v-icon class="mr-1">$sl-edit</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-card>

    <v-dialog v-model="dialog" max-width="350px">
      <v-card>
        <v-card-title>
          Sätt pris
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <div>
              <v-text-field outlined v-model="editedItem.price" label="Pris" :rules="[rules.number]"></v-text-field>
            </div>
            <div v-if="editedItem.assignments && editedItem.assignments.length">
              <h6>Uppgifter</h6>
              <template v-for="assignment in editedItem.assignments">
                <div :key="assignment.id">
                  <v-text-field outlined 
                    :label="assignment.name"
                    :rules="[rules.number]"
                    v-model="assignment.price"
                  />
                </div>
              </template>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn color="secondary" @click="cancel">
            <v-icon>$sl-cancel</v-icon>
            Avbryt
          </v-btn>
          <v-btn @click="save">
            <v-icon>$sl-check</v-icon>
            Spara
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="extensionDialog" max-width="350px">
      <v-card>
        <v-card-title>
          Sätt pris och längd pä förlängning
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <v-text-field outlined type="number" v-model="extensionModel.months" label="Förlängning (män)"
                              :rules="[rules.number]"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field outlined v-model="extensionModel.price" label="Pris"
                              :rules="[rules.number]"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn color="secondary" @click="closeExtensionDialog()">
            <v-icon>$sl-cancel</v-icon>
            Avbryt
          </v-btn>
          <v-btn @click="isExtensionNew ? addExtension() : editExtension()">
            <v-icon>$sl-check</v-icon>
            Spara
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {pageSize} from '@/store/constants'
import {RulesMixin} from '@/components/mixins'
// @group Ebook
// DistanceEducations component
export default {
  name: 'DistanceEducations',

  mixins: [RulesMixin],

  data: () => ({
    itemsPerPage: pageSize,
    totalRows: 0,
    courses: [],
    dialog: false,
    tab: null,
    editedItem: {
      id: -1,
      price: 0
    },
    defaultItem: {
      id: -1,
      price: 0
    },
    editedIndex: -1,
    distanceEducationProviders: [],
    distanceEducationProviderId: 0,
    extensionModel: {},
    extensionDialog: false,
    isExtensionNew: null,
    distanceEducationProviderExtensions: [],
  }),

  computed: {
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('basic', ['getProfessionNameById']),
  },

  created() {
    this.fetchProviders();
  },

  watch: {
    dialog(val) {
      val || this.cancel()
    }
  },

  methods: {
    /**
     * @vuese
     * Used to fetch educations list
     */
    fetchEducations() {
      API.listDistanceEducations(this.distanceEducationProviderId)
          .then(res => {
            this.totalRows = res.data.count
            this.courses = res.data.rows
          })
          .catch(err => {
            console.log(err)
          })
    },

    fetchProviders() {
      API.listDistanceEducationProviders()
          .then((res) => {
            this.distanceEducationProviders = res.data.map(it => ({key: it.id, value: it.name}));
          })
    },

    fetchExtensions() {
      API.listDistanceEducationProviderExtensions(this.distanceEducationProviderId)
      .then((res) => {
        this.distanceEducationProviderExtensions = res.data.rows;
      })
    },

    editItem(item) {
      this.editedIndex = this.courses.indexOf(item)
      if(this.editedIndex === -1){
        return 
      }

      this.editedItem = {
        id: item.id,
        price: item.price,
        assignments: item.assignments
      }
      this.dialog = true
    },

    addExtension() {
      API.createDistanceEducationProviderExtension({
        ...this.extensionModel,
        distanceEducationProviderId: this.distanceEducationProviderId
      })
          .then(() => {
            this.closeExtensionDialog();
            this.fetchExtensions();
          })
    },
    editExtension() {
      API.updateDistanceEducationProviderExtension(this.extensionModel.id, {
        ...this.extensionModel,
        distanceEducationProviderId: this.distanceEducationProviderId
      })
          .then(() => {
            this.closeExtensionDialog();
            this.fetchExtensions();
          })
    },

    closeExtensionDialog() {
      this.extensionModel = {};
      this.extensionDialog = false;
    },

    showExtensionDialog(item) {
      this.isExtensionNew = !item;
      this.extensionModel = item || {};
      this.extensionDialog = true;
    },

    /**
     * @vuese
     * Used to update distance education
     * @arg The argument is integer representing distance education  price
     */
    save() {
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Felaktigt angivet pris.')
        return
      }
      if (this.editedIndex > -1) {
        const data = {
          price: this.editedItem.price,
          assignments: this.editedItem.assignments?.length ? this.editedItem.assignments : null
        }
        API.updateDistanceEducations(this.editedItem.id, { data })
            .then(res => {
              this.courses[this.editedIndex] = {
                ...this.courses[this.editedIndex],
                price: this.editedItem.price,
                assignments: this.editedItem.assignments
              }
              this.cancel()
            })
            .catch(err => {
              this.$events.fire('showError', 'Kunde inte ändra priset.')
              console.log(err)
            })
      } else {
        //- New not supported here
        this.$events.fire('showError', 'Felaktig rad.')
      }
    },

    cancel() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    }
  }
}
</script>

<style>
.distance-select {
  width: 300px;
}
</style>
